<script setup lang="ts">
import { VButton, VDropdownMultiple, VIcon } from '@/modules/shared/components'
import VSelect from '../../../components/v-select.vue'
import AddressForm from '../../../components/address-form.vue'

const props = defineProps<{
  form: any
  v$: any
  managerOptions: { label: string; value: string }[]
  adminOptions: { label: string; value: string }[]
}>()

defineExpose({
  isValid: async () => {
    const fields = ['manager_id', 'admin_signer_id', 'admin_ids']
    const results = await Promise.all(fields.filter((f) => props.v$[f]).map((f) => props.v$[f].$validate()))
    return results.every(Boolean)
  },
})
</script>

<template>
  <div class="space-y-4">
    <VSelect
      v-model="form.manager_id"
      label="Who is the SPV manager?"
      :options="managerOptions"
      property="manager_id"
      :v$="v$"
    />
    <VSelect
      v-model="form.admin_signer_id"
      label="Who should sign documents?"
      :options="adminOptions"
      property="admin_signer_id"
      :v$="v$"
    />
    <fieldset class="space-y-4 rounded-lg border border-gray-300/50 bg-white p-4">
      <label class="block text-sm font-medium text-gray-800">
        Which individuals should have administrator rights?
      </label>
      <VDropdownMultiple
        aligned="left"
        class="z-auto"
        :options="adminOptions"
        property="admin_ids"
        v-model="form.admin_ids"
        :show-selected-list="true"
      >
        <VButton size="xl" class="w-full">
          <div class="flex items-center justify-between">
            <div>Select multiple...</div>
            <VIcon name="ChevronSelectorVertical" />
          </div>
        </VButton>
      </VDropdownMultiple>
      <p class="text-sm text-gray-500">By default, all group admins have administrator rights to this SPV.</p>
    </fieldset>

    <div class="my-8 h-px bg-gray-100"></div>

    <h3 class="text-base font-medium text-gray-900">Entity address</h3>
    <AddressForm :modelValue="form" :v$="v$" />
  </div>
</template>
